/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as React from "react";
import { Form, Container, Button } from "semantic-ui-react";

import { MedicalType } from "@teamprevent/common/healthSurveillance/models";

import { OhCase } from "../../crud/ohCase";

import { TaskType, AddTaskFormModel, AddTaskModel, mapToCreateTaskModel } from "../../task/model";

import { ImmunisationTypeTask } from "../../crud/immunisationTypeTask";
import { ImmunisationType } from "../../crud/immunisationType";

import { AddTasksInputs } from "./addTasksInputs";
import { ConfirmCaseCloseModal } from "./ConfirmCaseCloseModal";

interface Props {
    onSubmit: (createTasks: AddTaskModel[]) => void;
    onCancel?: () => void;
    taskTypes: TaskType[];
    immunisationTypes?: ImmunisationType[];
    immunisationTypeTasks?: ImmunisationTypeTask[];
    creatingTask: boolean;
    ohCaseId: string;
    ohCase?: OhCase;
    singleTask?: boolean;
    defaultDueDate?: boolean;
    submitButtonText?: string;
    medicalTypes?: MedicalType[];
    caseType?: string;
    assignmentOptionRequired?: boolean;
}

interface State {
    submitted: boolean;
    confirmCloseOpen: boolean;

    tasks: { task: AddTaskFormModel; isValid: boolean }[];
}

/**
 * @deprecated Prefer using AddTasksForm instead
 */
export class OldAddTasksForm extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
        this.state = {
            tasks: [{ task: { taskCode: null, taskType: null, dueDate: null, notes: null, caseType: null }, isValid: false }],
            submitted: false,
            confirmCloseOpen: false
        };
    }

    public render() {
        return (
            <>
                <Form onSubmit={this.onSubmitConfirmable}>
                    <AddTasksInputs
                        defaultDueDate={this.props.defaultDueDate}
                        onChange={this.onUpdateTasks}
                        taskTypes={this.props.taskTypes}
                        immunisationTypes={this.props.immunisationTypes}
                        immunisationTypeTasks={this.props.immunisationTypeTasks}
                        ohCaseId={this.props.ohCaseId}
                        showErrors={this.state.submitted}
                        singleTask={this.props.singleTask}
                        medicalTypes={this.props.medicalTypes}
                        caseType={this.props.caseType}
                        assignmentOptionRequired={this.props.assignmentOptionRequired}
                    />
                    {this.props.children}
                    <Container textAlign="right" fluid>
                        {this.props.onCancel && <Button
                            content="Cancel"
                            onClick={this.props.onCancel}
                        />}
                        <Button
                            icon="add"
                            content={this.props.submitButtonText || `Add Task${this.state.tasks.length > 1 ? "s" : ""}`}
                            loading={this.props.creatingTask}
                            disabled={this.props.creatingTask}
                        />
                    </Container>
                </Form>
                <ConfirmCaseCloseModal
                    loading={this.props.creatingTask}
                    isOpen={this.state.confirmCloseOpen}
                    onSubmit={this.onSubmit}
                    onCancel={this.onCancel}
                />
            </>
        );
    }

    private onSubmitConfirmable = () => {
        if ((!this.props.ohCase || this.props.ohCase.tasks.every(t => t.completed))
            && this.state.tasks.every(t => t.task.taskType.closesCase)) {
            this.setState({ confirmCloseOpen: true });
            return;
        }

        this.onSubmit();
    };

    private onSubmit = () => {
        this.setState({ submitted: true, confirmCloseOpen: false });
        if (this.state.tasks.some(t => !t.isValid)) {
            return;
        }

        this.props.onSubmit(this.state.tasks.map(t => t.task).filter(t => t).map(t => mapToCreateTaskModel(t, this.props.ohCaseId)));
    };

    private onCancel = () => this.setState({ confirmCloseOpen: false });

    private onUpdateTasks = (tasks: { task: AddTaskFormModel; isValid: boolean }[]) => this.setState({ tasks });
}
